var GOLD_ANIM_DEBUG = false;

var initAccordions = function () {
  var accElems = document.querySelectorAll("[data-gold-accordion]");
  Array.prototype.map.call(accElems, function (item, index) {
    var accButton = item.querySelector("[data-gold-accordion-button]");
    if (!accButton) return;
    var accButtonIcon = accButton.querySelector("i.expand-icon");
    var accContent = item.querySelector("[data-gold-accordion-content]");

    $(accButton)
      .off("click.accordion")
      .on("click.accordion", function () {
        accButtonIcon.classList.toggle("closed");
        $(accContent).slideToggle(350, function () {
          // if science accordion is open, trigger scroll to it
          if (
            accContent.style.display !== "none" &&
            accContent.classList.contains("gold-science__slide")
          ) {
            $("html, body").animate(
              { scrollTop: $(accContent).offset().top - 400 },
              600
            );
          }

          // trigger redraw gsap
          ScrollTrigger.refresh();
        });
      });
  });
};
var initScienceMobileAccordion = function () {
  var accButtons = document.querySelectorAll(
    "[data-gold-accordion-button-mobile]"
  );
  Array.prototype.map.call(accButtons, function (accButton, index) {
    var accIcon = accButton.querySelector("i.expand-icon");
    var accLabel = accButton.querySelector(
      "[data-gold-accordion-button-mobile-label]"
    );
    var accContent = accButton.querySelector(
      "[data-gold-accordion-button-mobile-content]"
    );

    $(accButton)
      .off("click.science-accordion")
      .on("click.science-accordion", function () {
        if (accIcon.classList.contains("closed")) {
          $(accLabel).fadeToggle(80, function () {
            $(accContent).slideToggle(350, function () {
              // trigger redraw gsap
              ScrollTrigger.refresh();
            });
          });
        } else {
          $(accContent).slideToggle(350, function () {
            $(accLabel).fadeToggle(80);
            // trigger redraw gsap
            ScrollTrigger.refresh();
          });
        }
        accIcon.classList.toggle("closed");
      });
  });
};
var initTestimonialsCap022 = function () {
  const component = document.getElementById('section-testimonials');
  if (!component) return;

  const expandButtons = component.querySelectorAll('[data-expand-btn]')
  const customers = component.querySelectorAll('[data-customer]');

  Array.prototype.map.call(expandButtons, function(expButton, index) {
    const $expBtn = $(expButton);
    $expBtn.parent().off('click.tab').on('click.tab', function() {
      const $selectedCustomer = $expBtn.closest('[data-customer]');
      console.log($selectedCustomer);

      // clear current selected
      $(customers).removeClass('selected');
      // set current customer selected
      $selectedCustomer.addClass('selected');
    });
  });

  $('[data-gold-testimonial-slider-main]').slick({
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    arrows: false,
    swipe: false,
  });

  // handle slide change on click
  $('[data-gold-testimonial-slider-sub]').on('init', function(slick) {
    $('[data-gold-testimonial-slider-sub] .slick-slide').off('click.slide').on('click.slide', function() {
      const selectedIdx = parseInt(this.dataset.slickIndex, 10);
      $('[data-gold-testimonial-slider-main]').slick('slickGoTo', selectedIdx + 1);
      $('[data-gold-testimonial-slider-sub]').slick('slickGoTo', selectedIdx + 1);
      $('[data-gold-testimonial-slider-content]').slick('slickGoTo', selectedIdx);
    })
  });
  

  $('[data-gold-testimonial-slider-sub]').slick({
    infinite: true,
    speed: 300,
    swipe: false,
    arrows: true,
    prevArrow:
      '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
    nextArrow:
      '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
    asNavFor: '[data-gold-testimonial-slider-sub], [data-gold-testimonial-slider-content]',
    asNavFor: '[data-gold-testimonial-slider-main], [data-gold-testimonial-slider-content]',
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          variableWidth: true,
        }
      },
      {
        breakpoint: 854,
        settings: {
          slidesToShow: 2,
          variableWidth: true,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('[data-gold-testimonial-slider-content]').slick({
    infinite: true,
    swipe: false,
    speed: 300,
    arrows: false,
    slidesToShow: 1,
    asNavFor: '[data-gold-testimonial-slider-main], [data-gold-testimonial-slider-sub]',
  });


};

var initAll = function () {
  if ("scrollRestoration" in history) {
    history.scrollRestoration = "auto";
  }
  initAccordions();
  initTestimonialsCap022();
  initScienceMobileAccordion();
};

document.onreadystatechange = function () {
  if (document.readyState === "complete") {
    initAll();
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      initAll();
    });
  }
};
